export default {
  namespaced: true,
  state: {
    keywordTargets: [],
    excludedItems: [],
    isSimple: false,
  },
  persistentStates: ['keywordTargets', 'excludedItems', 'isSimple'],
  mutations: {
    /**
     * stateを初期化する
     * @param {*} state
     */
    resetState(state) {
      state.keywordTargets = []
      state.excludedItems = []
      state.isSimple = false
    },
    /**
     * 検索項目を設定する
     * @param {*} state
     * @param {Array.<String>} targets 検索対象項目
     */
    setKeywordTargets(state, targets) {
      state.keywordTargets = targets
    },
    /**
     * 非表示表示項目を設定する
     * @param {*} state
     * @param {Array.<String>} items 非表示にする表示項目
     */
    setExcludedItems(state, items) {
      state.excludedItems = items
    },
    /**
     * カード簡易表示フラグを設定する
     * @param {*} state
     * @param {Boolean} isSimple 簡易表示するならtrue
     */
    setIsSimple(state, isSimple) {
      state.isSimple = isSimple
    },
  },
  getters: {
    /**
     * 検索項目
     * @param {*} state
     * @returns {Array.<String>}
     */
    keywordTargets: (state) => state.keywordTargets,
    /**
     * 非表示表示項目
     * @param {*} state
     * @returns {Array.<String>}
     */
    excludedItems: (state) => state.excludedItems,
    /**
     * カード簡易表示フラグ
     * @param {*} state
     * @returns {Boolean}
     */
    isSimple: (state) => state.isSimple,
  },
  actions: {
    /**
     * stateをリセットする
     */
    resetState({ commit }) {
      commit('resetState')
    },
    /**
     * 検索項目の設定
     * @param {Array.<String>} target 検索対象項目の設定値
     */
    setKeywordTargets({ commit }, target) {
      commit('setKeywordTargets', target)
    },
  },
}
